import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              {appData.description}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {appData.features.map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                  {f}
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="shrink-0">
            <div className="w-44 h-44 md:w-52 md:h-52 rounded-2xl overflow-hidden bg-background-100 p-3 border border-background-200/70">
              <img
                src={appData.qrImage}
                alt="包子漫画APP下载二维码"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-xs text-foreground-400 text-center mt-2">扫码下载APP</p>
          </div>
        </div>
      </div>
    </section>
  );
}